import { render, staticRenderFns } from "./AlarmTable.vue?vue&type=template&id=48a1a570&scoped=true"
import script from "./AlarmTable.vue?vue&type=script&lang=js"
export * from "./AlarmTable.vue?vue&type=script&lang=js"
import style0 from "./AlarmTable.vue?vue&type=style&index=0&id=48a1a570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a1a570",
  null
  
)

/* custom blocks */
import block0 from "./AlarmTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports